import React from 'react';
import TripReport from './TripReport';

const ReportsAnalyticsPage = () => {
  return (
    <div className="space-y-6">
      <TripReport />
    </div>
  );
};

export default ReportsAnalyticsPage;